import type { ICandidateTransition } from "@bbj-types/candidate";
import { useCallback } from "react";
import { axiosV2 } from "./axios";

export type TransitionType =
  | "authorsTransitions"
  | "statusTransitions"
  | "coachingStepTransitions"
  | "genericTransitions";

export const useGetCandidatesTransition = () => {
  const [state, execute, cancel] = axiosV2<ICandidateTransition>(
    {
      url: "",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: string, transitionTypes?: TransitionType[]) => {
      return execute({
        url: `/candidates/${id}/transitions`,
        params: { transitionTypes },
      });
    },
    [execute]
  );
  return [state, callback, cancel] as const;
};

export interface IPatchCandidateTransition {
  date: Date;
  value: string | string[];
}

export const usePatchCandidatesTransition = () => {
  const [state, execute, cancel] = axiosV2<ICandidateTransition>(
    {
      url: "/candidates/",
      method: "PATCH",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: string, transitionId: string, data: IPatchCandidateTransition, transitionType: TransitionType) => {
      return execute({
        url: `/candidates/${id}/transitions/${transitionId}`,
        params: { transitionType },
        data,
      });
    },
    [execute]
  );
  return [state, callback, cancel] as const;
};

export const useDeleteCandidatesTransition = () => {
  const [state, execute, cancel] = axiosV2<ICandidateTransition>(
    {
      url: "",
      method: "DELETE",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: string, transitionId: string, transitionType: TransitionType) => {
      return execute({
        url: `/candidates/${id}/transitions/${transitionId}`,
        params: {
          transitionType,
        },
      });
    },
    [execute]
  );
  return [state, callback, cancel] as const;
};
